"use strict";
/* Autogenerated file. Do not edit manually. */
/* tslint:disable */
/* eslint-disable */
Object.defineProperty(exports, "__esModule", { value: true });
exports.IServiceAgreementRegistry__factory = void 0;
const ethers_1 = require("ethers");
const _abi = [
    {
        inputs: [
            {
                internalType: "address",
                name: "consumer",
                type: "address",
            },
            {
                internalType: "address",
                name: "user",
                type: "address",
            },
        ],
        name: "addUser",
        outputs: [],
        stateMutability: "nonpayable",
        type: "function",
    },
    {
        inputs: [
            {
                components: [
                    {
                        internalType: "address",
                        name: "consumer",
                        type: "address",
                    },
                    {
                        internalType: "address",
                        name: "indexer",
                        type: "address",
                    },
                    {
                        internalType: "bytes32",
                        name: "deploymentId",
                        type: "bytes32",
                    },
                    {
                        internalType: "uint256",
                        name: "lockedAmount",
                        type: "uint256",
                    },
                    {
                        internalType: "uint256",
                        name: "startDate",
                        type: "uint256",
                    },
                    {
                        internalType: "uint256",
                        name: "period",
                        type: "uint256",
                    },
                    {
                        internalType: "uint256",
                        name: "planId",
                        type: "uint256",
                    },
                    {
                        internalType: "uint256",
                        name: "planTemplateId",
                        type: "uint256",
                    },
                ],
                internalType: "struct ClosedServiceAgreementInfo",
                name: "agreement",
                type: "tuple",
            },
        ],
        name: "createClosedServiceAgreement",
        outputs: [
            {
                internalType: "uint256",
                name: "",
                type: "uint256",
            },
        ],
        stateMutability: "nonpayable",
        type: "function",
    },
    {
        inputs: [
            {
                internalType: "uint256",
                name: "agreementId",
                type: "uint256",
            },
        ],
        name: "establishServiceAgreement",
        outputs: [],
        stateMutability: "nonpayable",
        type: "function",
    },
    {
        inputs: [
            {
                internalType: "uint256",
                name: "agreementId",
                type: "uint256",
            },
        ],
        name: "getClosedServiceAgreement",
        outputs: [
            {
                components: [
                    {
                        internalType: "address",
                        name: "consumer",
                        type: "address",
                    },
                    {
                        internalType: "address",
                        name: "indexer",
                        type: "address",
                    },
                    {
                        internalType: "bytes32",
                        name: "deploymentId",
                        type: "bytes32",
                    },
                    {
                        internalType: "uint256",
                        name: "lockedAmount",
                        type: "uint256",
                    },
                    {
                        internalType: "uint256",
                        name: "startDate",
                        type: "uint256",
                    },
                    {
                        internalType: "uint256",
                        name: "period",
                        type: "uint256",
                    },
                    {
                        internalType: "uint256",
                        name: "planId",
                        type: "uint256",
                    },
                    {
                        internalType: "uint256",
                        name: "planTemplateId",
                        type: "uint256",
                    },
                ],
                internalType: "struct ClosedServiceAgreementInfo",
                name: "",
                type: "tuple",
            },
        ],
        stateMutability: "view",
        type: "function",
    },
    {
        inputs: [
            {
                internalType: "address",
                name: "indexer",
                type: "address",
            },
            {
                internalType: "bytes32",
                name: "deploymentId",
                type: "bytes32",
            },
        ],
        name: "hasOngoingClosedServiceAgreement",
        outputs: [
            {
                internalType: "bool",
                name: "",
                type: "bool",
            },
        ],
        stateMutability: "view",
        type: "function",
    },
    {
        inputs: [],
        name: "nextServiceAgreementId",
        outputs: [
            {
                internalType: "uint256",
                name: "",
                type: "uint256",
            },
        ],
        stateMutability: "view",
        type: "function",
    },
    {
        inputs: [
            {
                internalType: "address",
                name: "consumer",
                type: "address",
            },
            {
                internalType: "address",
                name: "user",
                type: "address",
            },
        ],
        name: "removeUser",
        outputs: [],
        stateMutability: "nonpayable",
        type: "function",
    },
];
class IServiceAgreementRegistry__factory {
    static createInterface() {
        return new ethers_1.utils.Interface(_abi);
    }
    static connect(address, signerOrProvider) {
        return new ethers_1.Contract(address, _abi, signerOrProvider);
    }
}
exports.IServiceAgreementRegistry__factory = IServiceAgreementRegistry__factory;
IServiceAgreementRegistry__factory.abi = _abi;
